import React from 'react';
import PropTypes from 'prop-types';
import _e from 'common/localeUtil';
import FormFieldOneInput from './fields/FormFieldOneInput';

const RecaptchaForm = ({ errorMessage }) => {
	return (
		<FormFieldOneInput
			errorMessage={errorMessage}
			description={_e('add_recaptch_here')}
			fieldName="recaptcha"
			placeholder={`Recaptcha key`}
			help={
				<span>
					<a
						href="https://www.iqcomputing.com/support/articles/generate-google-recaptcha-v2-keys/"
						target="_blank"
						rel="noopener noreferrer"
					>
						{_e('how_to_get_recaptcha')}
					</a>
				</span>
			}
		/>
	);
};

RecaptchaForm.propTypes = {
	errorMessage: PropTypes.string
};

export default RecaptchaForm;
